let isAboveBreakpoint = false;

const breakpoint = 1024;
const isVisibleClass = "is-visible";
const isActiveClass = "is-active";
const accordionClass = "is-open";

function mainTopSpacing() {
  const headerGroup = document.querySelector("#header-group");
  const main = document.querySelector("#MainContent");
  main.style.paddingTop = `${headerGroup.offsetHeight}px`;
}

function isWindowWidthAbove(callback) {
  const checkWindowWidth = () => {
    const windowWidth = window.innerWidth;
    isAboveBreakpoint = windowWidth > breakpoint;
    callback(isAboveBreakpoint);
  };

  window.addEventListener("resize", checkWindowWidth);
  return checkWindowWidth();
}

function resetMenu(menuWrapper, listWrappers) {
  listWrappers.forEach((listWrapper) =>
    listWrapper.classList.remove(isVisibleClass, isActiveClass)
  );
  const menuLinks = menuWrapper.querySelectorAll("a");
  menuLinks.forEach((menuLink) => menuLink.classList.remove(isActiveClass));
  const accordionItems = menuWrapper.querySelectorAll(".level-3");
  accordionItems.forEach((item) => item.classList.remove(accordionClass));
  menuWrapper.classList.remove(isVisibleClass);
  const activeWrapper = document.querySelector(".list-wrapper.active-wrapper");
  if (activeWrapper) activeWrapper.classList.remove("active-wrapper");
}

function headerMenu() {
  const pageHeader = document.querySelector(".page-header");
  const searchMenu = document.querySelector("details-modal.header__search");
  const searchModal = document.querySelector(".search-modal");
  const searchIcon = document.querySelector(".header__icon--search");
  const toggleMenu = pageHeader.querySelector(".toggle-menu");
  const menuWrapper = pageHeader.querySelector(".menu-wrapper");
  const level1Links = pageHeader.querySelectorAll(".level-1 > li > a");
  const listWrappers = pageHeader.querySelectorAll(".list-wrapper");
  const backOneLevelBtns = pageHeader.querySelectorAll(".back-one-level");
  const level1ListItems = pageHeader.querySelectorAll(".level-1 > li");
  const subMenus = pageHeader.querySelectorAll(".sub-menu.level-2");

  searchModal.style.top = `${
    document.querySelector("#header-group").offsetHeight
  }px`;

  isWindowWidthAbove((isAbove) => {
    if (isAbove && menuWrapper.classList.contains(isVisibleClass)) {
      resetMenu(menuWrapper, listWrappers);
      menuWrapper.style.top = "";
      menuWrapper.style.height = "";
      menuWrapper.classList.remove(isVisibleClass);
    } else if (!isAbove && menuWrapper.classList.contains(isVisibleClass)) {
      menuWrapper.style.top = `${
        document.querySelector("#header-group").offsetHeight
      }px`;
      menuWrapper.style.height = `calc(100vh - ${
        document.querySelector("#header-group").offsetHeight
      }px)`;
    }
  });

  
  searchIcon.addEventListener("click", function () {
    if (searchMenu.querySelector("details").hasAttribute("open")) {
      document.body.classList.remove("overflow-hidden");
    } else {
      document.body.classList.add("overflow-hidden");
    }
    menuWrapper.style.top = "";
    menuWrapper.style.height = "";
    menuWrapper.classList.remove(isVisibleClass);
    toggleMenu.classList.remove(isVisibleClass);
    
  });

  toggleMenu.addEventListener("click", function () {
    if (!menuWrapper.classList.contains(isVisibleClass)) {
      resetMenu(menuWrapper, listWrappers);
      menuWrapper.style.top = `${
        document.querySelector("#header-group").offsetHeight - 2
      }px`;
      menuWrapper.style.height = `calc(100vh - ${
        document.querySelector("#header-group").offsetHeight
      }px)`;
    } else {
      menuWrapper.style.top = "";
      menuWrapper.style.height = "";
    }
    menuWrapper.classList.toggle(isVisibleClass);
    this.classList.toggle(isVisibleClass);
    if (searchMenu.querySelector("details").hasAttribute("open")) {
      searchMenu.querySelector("details").removeAttribute("open");
    }
    document.body.classList.toggle("overflow-hidden");
  });

  isWindowWidthAbove((isAbove) => {
    if (isAbove) {
      subMenus.forEach((subMenu) => {
        subMenu.style.top = `${
          document.querySelector("#header-group").offsetHeight - 2
        }px`;
      });
    } else {
      subMenus.forEach((subMenu) => {
        subMenu.style.top = "";
      });
    }
  });

  level1ListItems.forEach((level1ListItem) => {
    const level1Link = level1ListItem.querySelector("a");
    const subMenu = level1ListItem.querySelector(".sub-menu.level-2");
    let timeoutIdEnter;
    let timeoutIdLeave;
  
    level1Link.addEventListener("click", function (e) {
      const siblingList = this.nextElementSibling;
      if (siblingList && !isAboveBreakpoint) {
        e.preventDefault();
        this.classList.add(isActiveClass);
        handleSubmenu(siblingList, this.textContent);
      }
    });
  
    level1ListItem.addEventListener("mouseenter", function () {
      clearTimeout(timeoutIdLeave); // Clear timeout if exists
      if (isAboveBreakpoint && subMenu) {
        timeoutIdEnter = setTimeout(() => { // Add delay before it shows
          subMenu.style.transform = "translateY(0)";
        }, 320);
      }
    });
  
    level1ListItem.addEventListener("mouseleave", function () {
      clearTimeout(timeoutIdEnter); // Clear timeout if exists
      if (isAboveBreakpoint && subMenu) {
        timeoutIdLeave = setTimeout(() => { // Add delay before it hides
          subMenu.style.transform = "";
        }, 320); 
      }
    });
  });
  

  function accordion(e) {
    const level2Link = e.target.closest(".level-2 > .links a");
    if (level2Link && level2Link.classList.contains("nested")) {
      const siblingList = level2Link.nextElementSibling;
      if (siblingList) {
        e.preventDefault();
        level2Link.classList.toggle(isActiveClass);
        if (isAboveBreakpoint) {
          //handleSubmenu(siblingList, level2Link.textContent);
        } else {
          siblingList.classList.toggle(accordionClass);
        }
      }
    }
  }
  menuWrapper.addEventListener("click", function (e) {
    accordion(e);
  });

  function handleSubmenu(siblingList, textContent) {
    const parentListWrapper = siblingList.closest(".list-wrapper");
    const nextListWrapper = parentListWrapper.nextElementSibling;
    const subMenuWrapper = nextListWrapper.querySelector(".sub-menu-wrapper");
    const backLabel = nextListWrapper.querySelector(".back-one-level span");
    const cloneSiblingList = siblingList.cloneNode(true);
    subMenuWrapper.innerHTML = "";
    subMenuWrapper.append(cloneSiblingList);
    nextListWrapper.classList.add(isVisibleClass);
    backLabel.textContent = textContent;
    parentListWrapper.classList.add("active-wrapper");
    const firstLevel2Link = subMenuWrapper.querySelector(
      ".level-2 .links li a"
    );
    if (firstLevel2Link) {
      const mockEvent = {
        preventDefault: function () {},
        target: firstLevel2Link,
      };
      accordion(mockEvent);
    }
  }

  backOneLevelBtns.forEach((backOneLevelBtn) => {
    backOneLevelBtn.addEventListener("click", function () {
      if (!isAboveBreakpoint) {
        const parent = this.closest(".list-wrapper");
        parent.classList.remove(isVisibleClass);
        const activeElement = parent.querySelector(".is-active");
        if (activeElement) {
          activeElement.classList.remove(isActiveClass);
        }
        const activeWrapper = document.querySelector(
          ".list-wrapper.active-wrapper"
        );
        if (activeWrapper) activeWrapper.classList.remove("active-wrapper");
      }
    });
  });
}

function imgSwipe() {
  const imageContainers = Array.from(
    document.querySelectorAll(".product__media-item:not(.variant-hidden)")
  );

  // Check if there are any image containers, if not exit the function
  if (imageContainers.length === 0) {
    return;
  }

  let activeIndex = 0;

  // Reset and generate the dot indicators.
  const dotsContainer = document.getElementById("dots-container");

  // Check if dotsContainer exists, if not exit the function
  if (!dotsContainer) {
    return;
  }

  dotsContainer.innerHTML = "";
  imageContainers.forEach((_, i) => {
    const dot = document.createElement("div");
    dot.classList.add("dot");
    if (i === activeIndex) dot.classList.add("active");
    dotsContainer.appendChild(dot);
  });

  // Swipe function for mobile.
  function swipeImage() {
    imageContainers.forEach((container, i) => {
      container.classList.remove("active");
      dotsContainer.children[i].classList.remove("active");
      if (i === activeIndex) {
        container.classList.add("active");
        dotsContainer.children[i].classList.add("active");
      }
    });
  }

  // Detect swipe right and left for mobile.
  document.addEventListener("touchstart", handleTouchStart, false);
  document.addEventListener("touchmove", handleTouchMove, false);

  let xDown = null;

  function handleTouchStart(evt) {
    xDown = evt.touches[0].clientX;
  }

  function handleTouchMove(evt) {
    if (!xDown) {
      return;
    }

    let xUp = evt.touches[0].clientX;
    let xDiff = xDown - xUp;

    if (Math.abs(xDiff) > 5) {
      if (xDiff > 0) {
        // left swipe
        activeIndex =
          activeIndex + 1 >= imageContainers.length ? 0 : activeIndex + 1;
      } else {
        // right swipe
        activeIndex =
          activeIndex - 1 < 0 ? imageContainers.length - 1 : activeIndex - 1;
      }
      swipeImage();
    }

    xDown = null;
  }

  // Initial swipe to show the first image.
  swipeImage();
}


function cardSwatch() {
  document.addEventListener("change", function (e) {
    if (e.target.matches(".pill-swatch")) {
      var newImageSrc;
      if (e.target.classList.contains('jersey-card')) {
        console.log('jersey card');
        newImageSrc = e.target.dataset.img; // Get image source from data-img attribute
      } else {
        newImageSrc = e.target.dataset.featuredImage;
      }
      
      if (!newImageSrc) {
        return;
      }
      var variantId = e.target.dataset.variantId;
      var productCard = e.target.closest(".card-wrapper");

      var primaryImage = productCard.querySelector(".primary-image");
      primaryImage.classList.remove("in");
      primaryImage.classList.add("fade");

      setTimeout(function () {
        primaryImage.setAttribute("src", newImageSrc);
        primaryImage.setAttribute(
          "srcset",
          newImageSrc +
            " 533w," +
            newImageSrc +
            " 720w," +
            newImageSrc +
            " 940w," +
            newImageSrc +
            " 1066w"
        );

        setTimeout(function () {
          primaryImage.classList.add("in");
        }, 300); // This timeout should match the transition duration in your CSS
      }, 300); // This timeout should match the transition duration in your CSS

      // Update product card links with the new variant ID
      var productLinks = productCard.querySelectorAll("a");
      productLinks.forEach(function (link) {
        var originalHref = link.href;
        var baseUrl = originalHref.split("?")[0]; // Get base URL without parameters
        link.href = baseUrl + "?variant=" + variantId; // Append variant ID
      });

      var secondaryImages = productCard.querySelectorAll(".secondary-image");
      secondaryImages.forEach(function (img) {
        img.classList.remove("in");
        img.classList.add("fade");

        setTimeout(function () {
          img.parentNode.removeChild(img);
        }, 300); // This timeout should match the transition duration in your CSS
      });
    }
  });
}

function sizeRadioOrder(){
  var sizeOrder = [
    "40",
    "42",
    "44",
    "46",
    "48",
    "50",
    "52",
    "56",
    "58",
    "XS",
    "S",
    "M",
    "L",
    "XL",
    "2XL",
    "3XL"
  ];
  var sizeFilter = document.querySelector('fieldset.sizeRadios');
  if (!sizeFilter) {
    return;
  }
  var listItems = sizeFilter.querySelectorAll(".variant-option-wrapper");
  for (var i = 0; i < listItems.length; i++) {
    var size = listItems[i].querySelector("input[type=radio]").getAttribute("value");
    var order = sizeOrder.indexOf(size);
    if (order > -1) {
      listItems[i].style.order = order;
    } else { // Set a default high order for unrecognized sizes
      listItems[i].style.order = sizeOrder.length;
    }
  }
}

function videoDefer(){

   // Find all 'video-defer' elements
   let videoDefers = document.querySelectorAll('video-defer');
    
   // Iterate over all 'video-defer' elements
   videoDefers.forEach((videoDefer) => {
       // Get related elements
       let button = videoDefer.querySelector('button');
       let playIcon = button.querySelector('.play');
       let pauseIcon = button.querySelector('.pause');
       let previewImage = videoDefer.querySelector('.preview-image');
       let videoTemplate = videoDefer.querySelector('template.deferred.video');
       
       // Create a new node from the template content
       let videoNode = document.importNode(videoTemplate.content, true);
       
       // Add the video node to the DOM
       videoDefer.appendChild(videoNode);

       // Find the newly appended video
       let videoElement = videoDefer.querySelector('video');
       
       // If the video is available, try to play it
       if (videoElement) {
           videoElement.play().then(() => {
               // On successful play, hide the preview image and show the pause button
               previewImage.style.opacity = '0';
               playIcon.style.opacity = '0';
               pauseIcon.style.opacity = '1';
           }).catch((error) => {
               console.error('Video play failed:', error);
           });
       }

       // Add click event listener for pause button
       button.addEventListener('click', function() {
           // If the video is playing, pause it and swap the icons
           if (!videoElement.paused) {
               videoElement.pause();
               playIcon.style.opacity = '1';
               pauseIcon.style.opacity = '0';
           } else {
                // If the video is paused, play it and swap the icons
                videoElement.play();
                playIcon.style.opacity = '0';
                pauseIcon.style.opacity = '1';
           }
       });
   });
}

function filterTrigger () {
  var filterTrigger = document.querySelector('.gf-refine-toggle-mobile span');
}

function copyButton() {
  const copyButtons = document.querySelectorAll(".copy-button");
  copyButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const textToCopy = this.getAttribute("data-copy");
      if (textToCopy) {
        navigator.clipboard
          .writeText(textToCopy)
          .then(() => {
            this.classList.add("copied");
          })
          .catch((err) => {
            console.error("Could not copy text: ", err);
          });
      }
    });
  });
}

function horizontalScrollControls() {
  // Initial setup for static elements
  setupScrollButtons();
  
  // Check for dynamically loaded content periodically
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes && mutation.addedNodes.length > 0) {
        // Look for our product carousels in the added nodes
        for (let i = 0; i < mutation.addedNodes.length; i++) {
          const node = mutation.addedNodes[i];
          if (node.classList && 
              (node.classList.contains('product-carousel') || 
               node.querySelector('.product-carousel'))) {
            // New carousel detected, setup buttons
            setupScrollButtons();
            break;
          }
        }
      }
    });
  });
  
  // Observe the entire document for changes
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  // Function to set up scroll buttons
  function setupScrollButtons() {
    const scrollButtonContainers = document.querySelectorAll('.collection, .related-products, .collab-featured-collection');
    
    scrollButtonContainers.forEach((container) => {
      // Find the scroll container in each section
      let scrollContainer;
      
      if (container.classList.contains('collab-featured-collection')) {
        scrollContainer = container.querySelector('.horizontal-scroll');
      } else {
        scrollContainer = container.querySelector('.product-carousel');
      }
      
      // Get the buttons
      const scrollForward = container.querySelector('#scrollForward');
      const scrollBack = container.querySelector('#scrollBack');
      
      // Only set up if we haven't already (check with a data attribute)
      if (scrollContainer && scrollForward && scrollBack && !scrollContainer.getAttribute('data-scroll-initialized')) {
        // Mark as initialized to prevent duplicate event listeners
        scrollContainer.setAttribute('data-scroll-initialized', 'true');
        
        // Find the width of a scroll item plus margin
        const scrollItem = scrollContainer.querySelector('.scroll-block');
        const scrollAmount = scrollItem ? scrollItem.clientWidth + 20 : 300; // Default if not found
        
        // Add event listeners to buttons
        scrollForward.addEventListener('click', function() {
          scrollContainer.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        });
        
        scrollBack.addEventListener('click', function() {
          scrollContainer.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        });
      }
    });
  }
}


function lazyMediaFade () {
    // Function to handle the image loading
    function handleImageLoad(img) {
        img.onload = function() {
            this.style.opacity = '1';
            if (this.parentElement.classList.contains('loading')) {
                this.parentElement.classList.remove('loading');
            }
        };
        // Manually trigger opacity change if image is already loaded
        if (img.complete) {
            img.onload();
        }
    }

    // Initial application to existing images
    var images = document.querySelectorAll('.lazy-media-fade img:first-child');
    images.forEach(handleImageLoad);

    // MutationObserver to observe body for added nodes
    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            mutation.addedNodes.forEach(function(node) {
                // Check if the added node is an image inside .card__media
                if (node.nodeName === 'IMG' && node.parentElement.classList.contains('lazy-media-fade')) {
                    handleImageLoad(node);
                } else if (node.nodeType === 1) { // Check for Element nodes to find images within them
                    var addedImages = node.querySelectorAll('.lazy-media-fade img:first-child');
                    addedImages.forEach(handleImageLoad);
                }
            });
        });
    });

    // Configuration of the observer:
    var config = { childList: true, subtree: true };

    // Start observing the document body for added elements
    observer.observe(document.body, config);
}

function animateElements() {
      // Function to handle the intersection event
      function handleIntersection(entries, observer) {
        entries.forEach(entry => {
            // Check if the element is intersecting by at least 20%
            if (entry.isIntersecting && entry.intersectionRatio >= 0.2) {
                // Add the 'data-animate-start' attribute
                entry.target.setAttribute('data-animate-start', 'true');
                // Unobserve the element so the function only runs once per element
                observer.unobserve(entry.target);
            }
        });
    }

    // Create a new Intersection Observer instance
    const observer = new IntersectionObserver(handleIntersection, {
        threshold: 0.2 // 20% of the element's height must be visible
    });

    // Select all elements that have 'data-animate-in="true"'
    const animatedElements = document.querySelectorAll('[data-animate-in="true"]');

    // Observe each of these elements
    animatedElements.forEach(el => observer.observe(el));
}


window.addEventListener('load', function() {
  if (window.location.hash) {
    const headerHeight = 120; // Set this to the height of your header
    const target = document.querySelector(window.location.hash);
    const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;

  window.scrollTo({
    top: targetPosition,
    behavior: 'smooth'
  });
  }
});


var scripts = {
  init: function () {
    mainTopSpacing();
    headerMenu();
    imgSwipe();
    cardSwatch();
    sizeRadioOrder();
    videoDefer(); 
    filterTrigger();
    copyButton();
    lazyMediaFade();
    animateElements();
    horizontalScrollControls();
  },
};

document.addEventListener("DOMContentLoaded", function () {
  scripts.init();
});

// Dawn Scripts

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

// class MenuDrawer extends HTMLElement {
//   constructor() {
//     super();

//     this.mainDetailsToggle = this.querySelector("details");

//     this.addEventListener("keyup", this.onKeyUp.bind(this));
//     this.addEventListener("focusout", this.onFocusOut.bind(this));
//     this.bindEvents();
//   }

//   bindEvents() {
//     this.querySelectorAll("summary").forEach((summary) =>
//       summary.addEventListener("click", this.onSummaryClick.bind(this))
//     );
//     this.querySelectorAll("button:not(.localization-selector)").forEach(
//       (button) =>
//         button.addEventListener("click", this.onCloseButtonClick.bind(this))
//     );
//   }

//   onKeyUp(event) {
//     if (event.code.toUpperCase() !== "ESCAPE") return;

//     const openDetailsElement = event.target.closest("details[open]");
//     if (!openDetailsElement) return;

//     openDetailsElement === this.mainDetailsToggle
//       ? this.closeMenuDrawer(
//           event,
//           this.mainDetailsToggle.querySelector("summary")
//         )
//       : this.closeSubmenu(openDetailsElement);
//   }

//   onSummaryClick(event) {
//     const summaryElement = event.currentTarget;
//     const detailsElement = summaryElement.parentNode;
//     const parentMenuElement = detailsElement.closest(".has-submenu");
//     const isOpen = detailsElement.hasAttribute("open");
//     const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

//     function addTrapFocus() {
//       trapFocus(
//         summaryElement.nextElementSibling,
//         detailsElement.querySelector("button")
//       );
//       summaryElement.nextElementSibling.removeEventListener(
//         "transitionend",
//         addTrapFocus
//       );
//     }

//     if (detailsElement === this.mainDetailsToggle) {
//       if (isOpen) event.preventDefault();
//       isOpen
//         ? this.closeMenuDrawer(event, summaryElement)
//         : this.openMenuDrawer(summaryElement);

//       if (window.matchMedia("(max-width: 990px)")) {
//         document.documentElement.style.setProperty(
//           "--viewport-height",
//           `${window.innerHeight}px`
//         );
//       }
//     } else {
//       setTimeout(() => {
//         detailsElement.classList.add("menu-opening");
//         summaryElement.setAttribute("aria-expanded", true);
//         parentMenuElement && parentMenuElement.classList.add("submenu-open");
//         !reducedMotion || reducedMotion.matches
//           ? addTrapFocus()
//           : summaryElement.nextElementSibling.addEventListener(
//               "transitionend",
//               addTrapFocus
//             );
//       }, 100);
//     }
//   }

//   openMenuDrawer(summaryElement) {
//     setTimeout(() => {
//       this.mainDetailsToggle.classList.add("menu-opening");
//     });
//     summaryElement.setAttribute("aria-expanded", true);
//     trapFocus(this.mainDetailsToggle, summaryElement);
//     document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
//   }

//   closeMenuDrawer(event, elementToFocus = false) {
//     if (event === undefined) return;

//     this.mainDetailsToggle.classList.remove("menu-opening");
//     this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
//       details.removeAttribute("open");
//       details.classList.remove("menu-opening");
//     });
//     this.mainDetailsToggle
//       .querySelectorAll(".submenu-open")
//       .forEach((submenu) => {
//         submenu.classList.remove("submenu-open");
//       });
//     document.body.classList.remove(
//       `overflow-hidden-${this.dataset.breakpoint}`
//     );
//     removeTrapFocus(elementToFocus);
//     this.closeAnimation(this.mainDetailsToggle);
//   }

//   onFocusOut() {
//     setTimeout(() => {
//       if (
//         this.mainDetailsToggle.hasAttribute("open") &&
//         !this.mainDetailsToggle.contains(document.activeElement)
//       )
//         this.closeMenuDrawer();
//     });
//   }

//   onCloseButtonClick(event) {
//     const detailsElement = event.currentTarget.closest("details");
//     this.closeSubmenu(detailsElement);
//   }

//   closeSubmenu(detailsElement) {
//     const parentMenuElement = detailsElement.closest(".submenu-open");
//     parentMenuElement && parentMenuElement.classList.remove("submenu-open");
//     detailsElement.classList.remove("menu-opening");
//     detailsElement
//       .querySelector("summary")
//       .setAttribute("aria-expanded", false);
//     removeTrapFocus(detailsElement.querySelector("summary"));
//     this.closeAnimation(detailsElement);
//   }

//   closeAnimation(detailsElement) {
//     let animationStart;

//     const handleAnimation = (time) => {
//       if (animationStart === undefined) {
//         animationStart = time;
//       }

//       const elapsedTime = time - animationStart;

//       if (elapsedTime < 400) {
//         window.requestAnimationFrame(handleAnimation);
//       } else {
//         detailsElement.removeAttribute("open");
//         if (detailsElement.closest("details[open]")) {
//           trapFocus(
//             detailsElement.closest("details[open]"),
//             detailsElement.querySelector("summary")
//           );
//         }
//       }
//     };

//     window.requestAnimationFrame(handleAnimation);
//   }
// }

// customElements.define("menu-drawer", MenuDrawer);

// class HeaderDrawer extends MenuDrawer {
//   constructor() {
//     super();
//   }

//   openMenuDrawer(summaryElement) {
//     this.header = this.header || document.querySelector(".section-header");
//     this.borderOffset =
//       this.borderOffset ||
//       this.closest(".header-wrapper").classList.contains(
//         "header-wrapper--border-bottom"
//       )
//         ? 1
//         : 0;
//     document.documentElement.style.setProperty(
//       "--header-bottom-position",
//       `${parseInt(
//         this.header.getBoundingClientRect().bottom - this.borderOffset
//       )}px`
//     );
//     this.header.classList.add("menu-open");

//     setTimeout(() => {
//       this.mainDetailsToggle.classList.add("menu-opening");
//     });

//     summaryElement.setAttribute("aria-expanded", true);
//     window.addEventListener("resize", this.onResize);
//     trapFocus(this.mainDetailsToggle, summaryElement);
//     document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
//   }

//   closeMenuDrawer(event, elementToFocus) {
//     if (!elementToFocus) return;
//     super.closeMenuDrawer(event, elementToFocus);
//     this.header.classList.remove("menu-open");
//     window.removeEventListener("resize", this.onResize);
//   }

//   onResize = () => {
//     this.header &&
//       document.documentElement.style.setProperty(
//         "--header-bottom-position",
//         `${parseInt(
//           this.header.getBoundingClientRect().bottom - this.borderOffset
//         )}px`
//       );
//     document.documentElement.style.setProperty(
//       "--viewport-height",
//       `${window.innerHeight}px`
//     );
//   };
// }

// customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);


// Publisher function if not already defined
function publish(eventName, payload) {
  window.dispatchEvent(new CustomEvent(eventName, { detail: payload }));
}
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.handleChange.bind(this));
    this.mediaItems = {};
    
    if (!window.PUB_SUB_EVENTS) {
      window.PUB_SUB_EVENTS = {
        optionValueSelectionChange: 'optionValueSelectionChange',
        variantChange: 'variantChange'
      };
    }

    this.safePublish = (eventName, data) => {
      if (window.PUB_SUB_EVENTS && typeof publish === 'function') {
        publish(window.PUB_SUB_EVENTS[eventName], data);
      }
    };
  }

  connectedCallback() {
    this.updateOptions();
    this.updateMasterId();
    this.variantFilterImg();
    this.updatePickupAvailability();

    this.querySelectorAll('input[name="Color"]').forEach(input => {
      input.addEventListener('change', () => {
        this.updateVariantStatuses();
      });
    });
  }

  handleChange(event) {
    const target = this.getInputForEventTarget(event.target);
    
    this.updateSelectionMetadata(event);
    
    const productUrl = target.dataset.productUrl;
    if (productUrl) {
      this.handleProductUrlChange(productUrl);
    }

    this.safePublish('optionValueSelectionChange', {
      data: {
        event,
        target,
        selectedOptionValues: this.selectedOptionValues
      }
    });

    this.onVariantChange();
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    console.log(this.currentVariant);
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
  
    // Get the name of the option that changed
    const changedOption = this.getChangedOptionName();
    
    // Only update media if it's not a size change
    if (changedOption !== 'Size') {
      this.variantFilterImg();
    }
  
    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      // Only update media if it's not a size change
      if (changedOption !== 'Size') {
        this.updateMedia();
      }
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.currentVariant.options.forEach((option, index) => {
        const element = document.querySelector(`#option-value-${index + 1}`);
        if (element) {
          element.textContent = option;
        }
      });
    }
  }

  // Add this new method to detect which option changed
  getChangedOptionName() {
    const event = window.event;
    if (event && event.target) {
      const input = event.target.closest('input[type="radio"]');
      if (input) {
        return input.getAttribute('name');
      }
    }
    return null;
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  getVariantData() {
    if (!this.variantData) {
      this.variantData = JSON.parse(
        this.querySelector('[type="application/json"]').textContent
      );
    }
    return this.variantData;
  }

  variantFilterImg() {
    const mediaList = document.querySelector(".product__media-list");
    if (!mediaList) return;
  
    mediaList.classList.add("transition");
  
    setTimeout(() => {
      if (this.currentVariant && this.currentVariant.featured_image && this.currentVariant.featured_image.alt) {
        document
          .querySelectorAll("[variant-alt]")
          .forEach((img) => img.classList.add("variant-hidden"));
  
        const currentImgAlt = this.currentVariant.featured_image.alt;
        const alternateImages = `[variant-alt='${currentImgAlt}']`;
        document
          .querySelectorAll(alternateImages)
          .forEach((img) => img.classList.remove("variant-hidden"));
      } else {
        document
          .querySelectorAll("[variant-alt]")
          .forEach((img) => img.classList.remove("variant-hidden"));
      }
  
      const visibleImages = document.querySelectorAll("[variant-alt]:not(.variant-hidden)").length;
  
      if (visibleImages === 1) {
        mediaList.classList.add("one-media-item");
      } else {
        mediaList.classList.remove("one-media-item");
      }
  
      mediaList.classList.remove("transition");
  
      if (typeof imgSwipe === 'function') {
        imgSwipe();
      }
    }, 400);
  }
  async handleProductUrlChange(productUrl) {
    const sectionId = this.dataset.section;
    const selectedOptionValues = this.selectedOptionValues.join(',');
    const changedOption = this.getChangedOptionName();
    
    try {
        const response = await fetch(
            `${productUrl}?section_id=${sectionId}&option_values=${selectedOptionValues}`
        );
        
        if (!response.ok) throw new Error('Network response was not ok');
        
        const html = await response.text();
        await this.updateProductContent(html, changedOption);

        // After content update, reinitialize the variant
        this.updateOptions();
        this.updateMasterId();

        // Enable add to cart if variant is available
        if (this.currentVariant && this.currentVariant.available) {
            this.toggleAddButton(false);
        }

        // Update option value displays
        const options = ['Player', 'Size', 'Color', 'Department'];
        options.forEach((optionName, index) => {
            const input = this.querySelector(`input[name="${optionName}"]:checked`);
            if (input) {
                const optionValueElement = document.querySelector(`#option-value-${index + 1}`);
                if (optionValueElement) {
                    optionValueElement.textContent = input.value;
                }
            }
        });
    } catch (error) {
        console.error('Error fetching product content:', error);
    }
}

updateProductContent(html, changedOption) {
  const parser = new DOMParser();
  const newDocument = parser.parseFromString(html, 'text/html');

  const productElement = this.closest('.product');
  const newProductElement = newDocument.querySelector('.product');
  
  if (productElement && newProductElement) {
      // Update all form-related elements first
      const formElements = productElement.querySelectorAll('form[action="/cart/add"]');
      const newFormElements = newProductElement.querySelectorAll('form[action="/cart/add"]');
      formElements.forEach((form, index) => {
          if (newFormElements[index]) {
              form.innerHTML = newFormElements[index].innerHTML;
          }
      });

      // Only update media if it's not a size change
      if (changedOption !== 'Size') {
          const mediaWrapper = productElement.querySelector('.product__media-wrapper');
          const newMediaWrapper = newProductElement.querySelector('.product__media-wrapper');
          if (mediaWrapper && newMediaWrapper) {
              mediaWrapper.innerHTML = newMediaWrapper.innerHTML;
              this.variantFilterImg();
          }
      }

      // Always update price
      const priceElement = productElement.querySelector('.price');
      const newPriceElement = newProductElement.querySelector('.price');
      if (priceElement && newPriceElement) {
          priceElement.innerHTML = newPriceElement.innerHTML;
      }

      // Enable add to cart if the new variant is available
      const newVariantData = newDocument.querySelector('[type="application/json"]');
      if (newVariantData) {
          const variantInfo = JSON.parse(newVariantData.textContent);
          const currentVariant = variantInfo.find(v => 
              v.options.every((opt, index) => opt === this.options[index])
          );
          
          if (currentVariant && currentVariant.available) {
              this.toggleAddButton(false);
          }
      }

      // Only reinitialize image slider if we updated the media
      if (changedOption !== 'Size' && typeof imgSwipe === 'function') {
          imgSwipe();
      }
  }
}
  updateSelectionMetadata({ target }) {
    const { value, tagName, name } = target;
    
    // Update the option value display for the changed option
    const optionIndex = ['Player', 'Size', 'Color', 'Department'].indexOf(name) + 1;
    const optionValueElement = document.querySelector(`#option-value-${optionIndex}`);
    if (optionValueElement) {
      optionValueElement.textContent = value;
    }
    
    if (tagName === 'SELECT' && target.selectedOptions.length) {
      Array.from(target.options)
        .find(option => option.getAttribute('selected'))
        ?.removeAttribute('selected');
      
      target.selectedOptions[0].setAttribute('selected', 'selected');
      
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest('.product-form__input')
        ?.querySelector('[data-selected-value] > .swatch');

      if (selectedDropdownSwatchValue) {
        if (swatchValue) {
          selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
          selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
        } else {
          selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
          selectedDropdownSwatchValue.classList.add('swatch--unavailable');
        }
        
        selectedDropdownSwatchValue.style.setProperty(
          '--swatch-focal-point',
          target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
        );
      }
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = target.closest('.product-form__input')?.querySelector('[data-selected-value]');
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
}

// Update the updateMedia method with safety checks
updateMedia() {
  if (!this.currentVariant || !this.currentVariant.featured_media) return;

  const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
  );

  if (!mediaGalleries.length) return;

  mediaGalleries.forEach((mediaGallery) => {
      if (typeof mediaGallery.setActiveMedia === 'function') {
          mediaGallery.setActiveMedia(
              `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
              true
          );
      }
  });

  const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
  );
  if (!modalContent) return;

  const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
  );
  if (newMediaModal) {
      modalContent.prepend(newMediaModal);
  }
}

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const variantData = this.getVariantData();
    const selectedColor = this.querySelector('input[name="Color"]:checked')?.value;
    if (!selectedColor) return;
  
    const availableSizes = variantData
      .filter(variant => variant.option2 === selectedColor && variant.available)
      .map(variant => variant.option1);
      
    this.querySelectorAll('input[name="Size"]').forEach(input => {
      if (!availableSizes.includes(input.value)) {
        input.classList.add('disabled');
      } else {
        input.classList.remove('disabled');
      }
    });

    const selectedOptionOneVariants = this.getVariantData().filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updatePickupAvailability() {
    const pickUpIcon = document.querySelector('.pickup-availability-target .icon');
    const pickUpText = document.querySelector('.pickup-availability-target .text-target');

    if (this.currentVariant && this.currentVariant.available) {
      if (pickUpIcon) pickUpIcon.classList.remove('opacity-30');
      if (pickUpText && pickUpText.textContent !== 'Available for in-store pickup (select at checkout)') {
        pickUpText.classList.add('transition-opacity', 'opacity-0');
        setTimeout(() => {
          pickUpText.textContent = 'Available for in-store pickup (select at checkout)';
          pickUpText.classList.remove('opacity-0');
        }, 500);
      }
    } else {
      if (pickUpIcon) pickUpIcon.classList.add('opacity-30');
      if (pickUpText && pickUpText.textContent !== 'Not available for in-store pickup') {
        pickUpText.classList.add('transition-opacity', 'opacity-0');
        setTimeout(() => {
          pickUpText.textContent = 'Not available for in-store pickup';
          pickUpText.classList.remove('opacity-0');
        }, 500);
      }
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);
        if (price) price.classList.remove("visibility-hidden");

        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`
        );
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
          window.variantStrings.soldOut
        );

        this.safePublish('variantChange', {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(
      this.querySelectorAll('select option[selected], fieldset input:checked')
    ).map(({ dataset }) => dataset.optionValueId);
  }
}

customElements.define('variant-selects', VariantSelects);
class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}
customElements.define("variant-radios", VariantRadios);
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);
